'use strict';

var StatusFilter = function () {
  return function (user) {
    if (user.isDeleted) {
      return 'Deleted';
    } else if (user.isDisabled) {
      return 'Disabled';
    } else {
      return 'Active';
    }
  };
};

module.exports = StatusFilter;



// WEBPACK FOOTER //
// ./src/app/settings/filters/StatusFilter.js